// WhatsApp balonu önizlemeleri: Meta şablonu (components) ve WhatsApp Web mesaj tipleri.
import React from 'react';
import _ from 'lodash';
import { Icon, COLORS } from './ui';

const tagged = (tag, str) => `<${tag}>${str}</${tag}>`;
const TAGS = { '~': 's', '*': 'b', _: 'em' };
const ESCAPED = { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;', '\n': '<br>', '\\n': '<br>' };

export function escapeHTML(text) {
	if (!text) return text || '';
	return String(text).replace(/\\n|[<>&"`'\n]/g, (ch) => ESCAPED[ch] || '');
}
// WhatsApp biçimlemesi: *kalın* _italik_ ~üstü çizili~
export function markdown(str = '') {
	return str.replace(/([*~_]{1,5})([^\s_*~].*?)\1/g, (a, b, c) => {
		if (TAGS[b] && c) return tagged(TAGS[b], markdown(c));
		return a;
	});
}
function Rich({ text }) {
	if (!text) return null;
	return <div style={{ whiteSpace: 'normal' }} dangerouslySetInnerHTML={{ __html: markdown(escapeHTML(text)) }} />;
}

export function mediaKind(url, file_format) {
	if (file_format) return file_format;
	url = url || '';
	if (/^https?:\/\/.*\/.*\.(png|gif|webp|jpeg|jpg)\??.*$/im.test(url)) return 'image';
	if (/^https?:\/\/.*\/.*\.(mp4)\??.*$/im.test(url)) return 'video';
	if (/^https?:\/\/.*\/.*\.(ogg|mp3)\??.*$/im.test(url)) return 'audio';
	return 'unvalid';
}

export const comp = (tpl, type) => tpl && _.find(tpl.components, (c) => (c.type || '').toUpperCase() === type);

export function WaFrame({ title, children, style }) {
	return (
		<div className="wsm-wa" style={style}>
			{title ? <div className="wsm-wa-title">{title}</div> : null}
			{children}
		</div>
	);
}

function MediaBox({ kind, label }) {
	return (
		<div className="wsm-wa-media">
			<Icon name={kind === 'video' ? 'play' : kind === 'image' ? 'image' : 'file'} size={16} color={COLORS.hint} />
			{label}
		</div>
	);
}

function Time() {
	return <div className="wsm-wa-time">10:00 ✓✓</div>;
}

// Şablon önizlemesi. Listeden doldurulan değişkenler [Alan] olarak gösterilir.
export function TemplateBubble({ tpl, params, image, cards, empty }) {
	if (!tpl) return <div className="wsm-wa-bubble wsm-wa-empty">{empty || 'Önizleme için bir şablon seçin.'}</div>;
	const fill = (type, text) => {
		if (!text) return text;
		return text.replace(/{{\s*[A-Za-z0-9_]+\s*}}/g, (code) => {
			const tp = params && params[`${type}-${code}`];
			if (!tp || !tp.value) return code;
			return tp.mode === 'field' ? `[${tp.value}]` : tp.value;
		});
	};
	const header = comp(tpl, 'HEADER');
	const body = comp(tpl, 'BODY');
	const footer = comp(tpl, 'FOOTER');
	const buttons = comp(tpl, 'BUTTONS');
	const carousel = comp(tpl, 'CAROUSEL');
	const format = header && (header.format || '').toUpperCase();
	const mediaUrl = image || (header && header.example && header.example.header_handle && header.example.header_handle[0]);
	return (
		<>
			<div className="wsm-wa-bubble">
				{format === 'IMAGE' ? (
					mediaUrl ? (
						<img alt="" src={mediaUrl} />
					) : (
						<MediaBox kind="image" label="Görsel" />
					)
				) : format === 'VIDEO' ? (
					mediaUrl ? (
						<video controls>
							<source src={mediaUrl} type="video/mp4" />
						</video>
					) : (
						<MediaBox kind="video" label="Video" />
					)
				) : format === 'DOCUMENT' ? (
					<MediaBox kind="document" label={'Belge · ' + tpl.name} />
				) : header && header.text ? (
					<div className="wsm-wa-head">{fill('HEADER', header.text)}</div>
				) : null}
				{body && body.text ? <div>{fill('BODY', body.text)}</div> : null}
				{footer && footer.text ? <div className="wsm-wa-foot">{footer.text}</div> : null}
				{carousel ? (
					<div className="wsm-wa-foot">
						Carousel · {(cards && cards.length) || (carousel.cards || []).length} kart
					</div>
				) : null}
				<Time />
			</div>
			{buttons && buttons.buttons && buttons.buttons.length ? (
				<div className="wsm-wa-btns">
					{buttons.buttons.map((b, i) => {
						const type = (b.type || '').toUpperCase();
						return (
							<div key={i} className="wsm-wa-btn">
								{type === 'URL' ? <Icon name="external" size={13} /> : type === 'PHONE_NUMBER' ? <Icon name="phone" size={13} /> : <Icon name="reply" size={13} />}
								{b.text}
							</div>
						);
					})}
				</div>
			) : null}
		</>
	);
}

// WhatsApp Web gönderiminde mesaj tipine göre önizleme
export function MessageBubble({ type, message, text, fileFormat, fileName, empty }) {
	if (!message) return <div className="wsm-wa-bubble wsm-wa-empty">{empty || 'Mesaj yazdıkça burada görünür.'}</div>;
	if (type === 'text')
		return (
			<div className="wsm-wa-bubble">
				<Rich text={message} />
				<Time />
			</div>
		);
	if (type === 'link')
		return (
			<div className="wsm-wa-bubble">
				<a target="_blank" rel="noopener noreferrer" href={message}>
					{message}
				</a>
				<Rich text={text} />
				<Time />
			</div>
		);
	if (type === 'document')
		return (
			<div className="wsm-wa-bubble">
				<MediaBox kind="document" label={fileName || message.split('/').pop().split('?')[0].slice(0, 40)} />
				<Rich text={text} />
				<Time />
			</div>
		);
	const kind = mediaKind(message, fileFormat);
	return (
		<div className="wsm-wa-bubble">
			{kind === 'image' ? (
				<img alt="" src={message} />
			) : kind === 'video' ? (
				<video controls>
					<source src={message} type="video/mp4" />
				</video>
			) : kind === 'audio' ? (
				<audio controls>
					<source src={message} type="audio/ogg" />
					<source src={message} type="audio/mpeg" />
				</audio>
			) : (
				<MediaBox kind="file" label="Desteklenmeyen biçim" />
			)}
			<Rich text={text} />
			<Time />
		</div>
	);
}
